<template lang="pug">
    v-dialog(
        v-model="_value"
        width="700px"
        :transition="false"
        )
        v-toolbar(
            :color="colors.primary"
            dark
        )
            v-icon.mr-2 search
            h1.title Búsqueda - Selección Múltiple
            v-progress-circular.loader(
                indeterminate
                v-if="loading"
            )
        v-card.pt-4.px-4
            v-text-field(
                v-if="state === 1"
                ref="inp1"
                v-model="alias"
                label="Código Interno"
                outline
                @blur="handleBlur('inp1')"
                @keydown="handleKeyDown($event)"
                @keydown.enter="fetchProducts"
                @keydown.esc="_value = false"
                :disabled="loading"
                )
            v-autocomplete(
                :search-input="alias"
                ref="inp2"
                v-if="state === 2"
                :items="options"
                outline
                label="producto"
                item-value="id"
                v-model="product"
                @blur="fetchAndAddProducts()"
                @keydown="handleKeyDown($event)"
                @keydown.esc="_value = false"
                :disabled="loading"
                multiple
                chips
                deletable-chips
            )
            span.px-2.subheading.green--text(
                v-show="state === 2"
            )
                v-icon.mr-2(color="green darken-3") info
                span {{options.length}} resultados encontrados
            span.title(v-if="state === 3")
                | Producto: {{product.name}}
            v-text-field(
                outline
                ref="inp3"
                mask="##########"
                label="cantidad"
                v-model="quantity"
                @keydown="handleKeyDown($event)"
                @keydown.esc="_value = false"
                @keydown.enter="addToCart"
                @blur="handleBlur('inp3')"
                v-if="state === 3"
            )
            span.px-2.subheading.red--text(
                v-show="errorMessage"
            )
                v-icon.mr-2(color="red") error
                span Error: {{errorMessage}}
</template>

<script>
// -- Component Imports --
// -- JS Data files import --
// -- JS Libraries Import --
import ProductModel from '@/models/Warehouse/WhProduct'
import axios from 'axios'
// -- Mixins imports --
// -- Vuex Imports --
import { mapGetters, mapActions, mapState } from 'vuex'
import { CurrencyUtils } from '@/mixins/reusable_mixins'
// -- Other Imports --
export default {
    name: 'multi-select-search-modal',
    props: {
        // ------------------------- UI State ---------------------------------
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false,
        },
        // ------------------------- Component Data ---------------------------
    },
    data: function() {
        return {
            // ------------------------ UI State ------------------------------
            loading: false,
            state: 1,
            // ------------------------ Data storing --------------------------
            alias: '',
            product: null,
            quantity: '',
            errorMessage: '',
            options: [],
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        /**
         * @description
         */
        _value: {
            get: function() {
                return this.value
            },
            set: function(val) {
                this.$emit('input', val)
            },
        },
        ...mapGetters('AuthModule', { userOfficeID: 'userOfficeID' }),
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        initialData() {
            return {
                loading: false,
                state: 1,
                alias: '',
                product: null,
                quantity: '',
                errorMessage: '',
                options: [],
            }
        },
        resetData() {
            Object.assign(this.$data, this.initialData())
        },
        // -------------------- Data fetching ---------------------------------
        fetchProducts() {
            if (this.alias.length < 3) {
                this.errorMessage = 'Deben ingresarse al menos 3 caractéres'
                return
            }
            this.loading = true
            const route =
                process.env.VUE_APP_API_ROUTE +
                `/wh_product_slim_multiple_filter?search_string=${this.alias}`
            // const route =
            //     process.env.VUE_APP_API_ROUTE +
            //     `/wh_product_pos_slim_filter_alias_name?alias_name=${this.alias}`
            axios
                .get(route)
                .then(response => {
                    if (response.data.data.length > 1) {
                        this.errorMessage = ''
                        this.state = 2
                        this.loading = false
                        this.options = response.data.data.map(itm => {
                            itm.text = `${itm.alias_name} - ${itm.name}`
                            return itm
                        })
                        return response
                    } else if (response.data.data.length === 1) {
                        this.errorMessage = ''
                        this.product = response.data.data[0]
                        this.state = 3
                        this.loading = false
                    } else {
                        this.errorMessage =
                            'No se encontraron productos con este código'
                        this.loading = false
                    }
                })
                .catch(e => {
                    this.errorMessage = e.response.data.data.message
                    this.loading = false
                    this.handleBlur('inp1')
                })
        },
        extractSalePrice(item) {
            if (!item.sale_prices || !item.sale_prices.length) return 'err.'
            let officePrice = item.sale_prices.find(
                p => p.branch_office_id === this.userOfficeID
            )
            if (!officePrice || !officePrice.sale_price) return 'no def.'
            return officePrice.sale_price
        },
        selectProduct(id = this.product.id) {
            this.loading = true
            ProductModel.append('sale_prices', 'stocks')
                .include('wh_product_upc_code')
                .find(id)
                .then(res => {
                    res.sale_price = this.extractSalePrice(res)
                    if (res.upc_codes && res.upc_codes.length)
                        res.upc = res.upc_codes[0]
                    this.product = res
                    this.state = 3
                    this.loading = false
                })
                .catch(e => {
                    this.errorMessage = e.response.data.message
                    this.state = 2
                    this.loading = false
                })
        },
        fetchAndAddProducts(idList = this.product) {
            if (this.loading) return
            if (!idList || idList.length === 0) {
                this.errorMessage = 'Debe seleccionar al menos un producto'
                return false
            }
            this.loading = true
            let queryStr = idList.join()
            let includes = 'wh_product_upc_code' //`sl_wholesale_discounts,wh_product_upc_code`
            let appends = `sale_prices,stocks`
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/wh_product?filter[wh_product_ids]=${queryStr}&include=${includes}&append=${appends}&get_all_results=true`
            axios.get(route).then(this.emitProducts)
        },
        emitProducts(response) {
            let newItems = response.data.data.map(p => {
                p.quantity = p.stock
                p.sale_price = this.extractSalePrice(p)
                if (p.upc_codes && p.upc_codes.length) p.upc = p.upc_codes[0]
                return p
            })
            this.$emit('products', newItems)
            this.loading = false
            this._value = false
        },
        formatNumber(number, prefix = '') {
            if (isNaN(number)) number = parseFloat(number)
            let n = number
            n = parseFloat(n.toString())
            return prefix + this.mixCurrencyFormatter(n)
        },
        // -------------------- Data handling and transformations -------------
        addToCart() {
            let quantity = this.quantity || this.product.stock || 1
            let product = this.product
            product.quantity = quantity
            this.$emit('products', [product])
            this.resetData()
        },
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        handleBlur(ref = 'inp1') {
            this.$nextTick(() => this.$refs[ref].focus())
        },
        handleKeyDown(e) {
            if (e.keyCode === 123) this._value = false
            if (e.keyCode === 113) {
                this.$emit('mode:quick')
                this._value = false
            }
        },
        // -------------------- Vuex mappings ---------------------------------
    },
    watch: {
        value: {
            handler(val) {
                this.resetData()
                if (val) {
                    this.$nextTick(() => this.$refs.inp1.focus())
                } else {
                }
            },
            inmediate: true,
        },
        state: {
            handler(val) {
                this.$nextTick(() => this.$refs[`inp${val}`].focus())
            },
        },
    },
    // components: {},
    mixins: [CurrencyUtils],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss">
.loader {
    position: absolute;
    right: 30px;
}
</style>
